import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  className: '',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '620028ef-8cf6-4b94-9094-3d9e86c5b066',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: 'a0f02cc7-3f5d-470b-b9d0-e523ddeee387',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 70,
      y: 174,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '620028ef-8cf6-4b94-9094-3d9e86c5b066',
      data: ''
    },
    {
      id: '8da4f85b-4ced-4741-97d7-6cca60b2938d',
      type: 'Container',
      name: 'RankMilestone',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a0f02cc7-3f5d-470b-b9d0-e523ddeee387',
      data: ''
    },
    {
      id: 'b1006237-0830-45f5-a0df-ca77942b6e04',
      type: 'Text',
      name: 'RankText',
      nameSpace: '',
      className: '',
      x: 1,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '3',
      localize: false,
      maxWidth: 120,
      maxHeight: 40,
      maxFontSize: 24,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8d3321',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'a0f02cc7-3f5d-470b-b9d0-e523ddeee387',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class SeasonPassRankMilestone {
  static raw = raw;
  root: PIXI.Container
  RankMilestone: PIXI.Container
  RankText: PIXI.Text
  RankLeaf: PIXI.Sprite

  constructor() {
    populate(this, raw);
  }
}
